<template>
    <div class="mobile-user-center">
        <HeaderMobile />
        
        <!-- 个人信息卡片 -->
        <div class="user-info-card">
            <div class="user-header">
                <img :src="userInfo.originalAvatar ? resourceUrl + userInfo.originalAvatar : ''" alt="头像" class="user-avatar" @error="handleAvatarError">
                <div class="user-base">
                    <h3>{{ userInfo.nickname }}</h3>
                    <p :class="userInfo.group_id == 2 ? 'teacher-role' : 'student-role'">
                        <i :class="userInfo.group_id == 2 ? 'el-icon-trophy' : 'el-icon-user'"></i>
                        {{ userInfo.group_id == 2 ? '认证教师' : '普通学员' }}
                    </p>
                </div>
            </div>
            <div class="user-stats">
                <div class="stats-item">
                    <span class="stats-num">{{ userInfo.coll_count || 0 }}</span>
                    <span class="stats-text">收藏课程</span>
                </div>
                <div class="stats-item">
                    <span class="stats-num">{{ userInfo.buy_count || 0 }}</span>
                    <span class="stats-text">已购课程</span>
                </div>
                <div class="stats-item" v-if="userInfo.group_id == 2">
                    <span class="stats-num">{{ userInfo.send_count || 0 }}</span>
                    <span class="stats-text">发布课程</span>
                </div>
            </div>
        </div>

        <!-- 功能菜单 -->
        <div class="menu-list">
            <div class="menu-item" @click="activeNav = 'profile'">
                <i class="el-icon-user"></i>
                <span>个人信息</span>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="menu-item" @click="activeNav = 'courses'">
                <i class="el-icon-folder-opened"></i>
                <span>我的课程</span>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="menu-item" @click="activeNav = 'wallet'">
                <i class="el-icon-wallet"></i>
                <span>我的钱包</span>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="menu-item" @click="activeNav = 'teacher'" v-if="false">
                <i class="el-icon-trophy"></i>
                <span>教师中心</span>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="menu-item" @click="activeNav = 'security'">
                <i class="el-icon-lock"></i>
                <span>账户安全</span>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>

        <!-- 个人信息弹窗 -->
        <el-dialog title="个人信息" :visible.sync="showProfile" fullscreen>
            <el-form :model="userForm" label-width="80px" size="small">
                <el-form-item label="用户名"><el-input v-model="userForm.username"></el-input></el-form-item>
                <el-form-item label="昵称"><el-input v-model="userForm.nickname"></el-input></el-form-item>
                <el-form-item label="手机号"><el-input v-model="userForm.mobile" disabled></el-input></el-form-item>
                <el-form-item label="邮箱"><el-input v-model="userForm.email"></el-input></el-form-item>
                <el-form-item label="性别">
                    <el-select v-model="userForm.gender" style="width: 100%;">
                        <el-option label="男" :value="1"></el-option>
                        <el-option label="女" :value="2"></el-option>
                        <el-option label="保密" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生日">
                    <el-date-picker v-model="userForm.birthday" type="date" placeholder="请选择生日" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="个人简介">
                    <el-input v-model="userForm.motto" type="textarea" :rows="3" placeholder="请输入个人简介"></el-input>
                </el-form-item>
                <el-form-item><el-button type="primary" @click="saveProfile" style="width: 100%;">保存修改</el-button></el-form-item>
            </el-form>
        </el-dialog>

        <!-- 我的课程弹窗 -->
        <el-dialog title="我的课程" :visible.sync="showCourses" fullscreen>
            <el-tabs v-model="courseTab" @tab-click="handleCourseTabChange">
                <el-tab-pane label="已付费课程" name="paid">
                    <div class="course-list" v-if="courseList && courseList.length > 0">
                        <div class="course-item" v-for="course in courseList" :key="course.id">
                            <img :src="getImageUrl(course.cover)" alt="课程封面" @error="handleCourseCoverError">
                            <div class="course-info">
                                <h3>{{ course.name }}</h3>
                                <p><i class="el-icon-user"></i>{{ course.author_name }}</p>
                                <p v-if="course.pay_time" style="font-size: 12px; color: #999;"><i class="el-icon-time"></i> 购买时间：{{ course.pay_time }}</p>
                                <p v-if="course.order_no" style="font-size: 12px; color: #999;">
                                    <i class="el-icon-document"></i> 订单号：{{ course.order_no }}
                                    <i class="el-icon-copy-document" style="color: #1890ff; cursor: pointer; margin-left: 4px;" @click.stop="copyOrderNo(course.order_no)"></i>
                                </p>
                                <div class="course-actions">
                                    <el-button type="primary" size="mini" @click="continueLearn(course.id)" :disabled="course.status != 'succ' || course.refund_sh != 0">继续学习</el-button>
                                    <el-button type="warning" size="mini" @click="applyRefund(course)" v-if="course.status == 'succ'" :disabled="course.refund_sh == '1' || course.refund_sh == '2'">{{ course.refund_sh == 1 ? '退款申请中' : '申请退款' }}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-state" v-else><i class="el-icon-s-data"></i><p>暂无课程</p></div>
                    <div class="pagination-wrap" v-if="courseTotal > 0" style="margin-top: 15px; text-align: center;">
                        <el-pagination background layout="prev, pager, next" :current-page="coursePage" :page-size="coursePageSize" :total="courseTotal" @current-change="handleCoursePageChange" small></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="我的收藏" name="coll">
                    <div class="course-list" v-if="courseList && courseList.length > 0">
                        <div class="course-item" v-for="course in courseList" :key="course.id">
                            <img :src="getImageUrl(course.cover)" alt="课程封面" @error="handleCourseCoverError">
                            <div class="course-info">
                                <h3>{{ course.name }}</h3>
                                <p><i class="el-icon-user"></i>{{ course.author_name }}</p>
                                <div class="course-actions">
                                    <el-button type="primary" size="mini" @click="continueLearn(course.id)">继续学习</el-button>
                                    <el-button type="text" size="mini" @click="removeCourse(course.id)">移出</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-state" v-else><i class="el-icon-s-data"></i><p>暂无课程</p></div>
                    <div class="pagination-wrap" v-if="courseTotal > 0" style="margin-top: 15px; text-align: center;">
                        <el-pagination background layout="prev, pager, next" :current-page="coursePage" :page-size="coursePageSize" :total="courseTotal" @current-change="handleCoursePageChange" small></el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

        <!-- 钱包弹窗 -->
        <el-dialog title="我的钱包" :visible.sync="showWallet" fullscreen>
            <div class="wallet-balance">
                <p>账户余额（元）</p>
                <h2>¥{{ walletInfo.balance || 0 }}</h2>
                <p style="font-size: 12px; opacity: 0.8; margin-top: 5px;">申请中金额：¥{{ walletInfo.freezeBalance || 0 }}</p>
                <el-button type="warning" size="small" @click="openWithdrawDialog" style="margin-top: 10px;">申请提现</el-button>
            </div>
            <el-tabs v-model="billType" @tab-click="handleBillTypeChange" style="margin-top: 15px;">
                <el-tab-pane label="全部账单" :name="0">
                    <div class="bill-list" v-if="billList && billList.length > 0">
                        <div class="bill-item" v-for="bill in billList" :key="bill.id">
                            <div class="bill-info">
                                <p class="bill-type">{{ bill.typeText }}</p>
                                <p class="bill-time">{{ bill.create_time }}</p>
                                <p class="bill-remark" v-if="bill.remark">{{ bill.remark }}</p>
                            </div>
                            <div class="bill-right">
                                <span class="bill-amount" :class="bill.type == 1 ? 'text-green' : 'text-red'">{{ bill.type == 1 ? '+' : '-' }}{{ bill.amount || 0 }}</span>
                                <el-tag :type="bill.status === 'succ' ? 'success' : 'warning'" size="mini" style="margin-top: 5px;">{{ bill.statusText }}</el-tag>
                            </div>
                        </div>
                    </div>
                    <div class="empty-state" v-else><i class="el-icon-s-data"></i><p>暂无账单记录</p></div>
                    <div class="pagination-wrap" v-if="billTotal > 0" style="margin-top: 15px; text-align: center;">
                        <el-pagination background layout="prev, pager, next" :current-page="billPage" :page-size="billPageSize" :total="billTotal" @current-change="handleBillPageChange" small></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="收入" :name="1">
                    <div class="bill-list" v-if="billList && billList.length > 0">
                        <div class="bill-item" v-for="bill in billList" :key="bill.id">
                            <div class="bill-info">
                                <p class="bill-type">{{ bill.typeText }}</p>
                                <p class="bill-time">{{ bill.create_time }}</p>
                                <p class="bill-remark" v-if="bill.remark">{{ bill.remark }}</p>
                            </div>
                            <div class="bill-right">
                                <span class="bill-amount" :class="bill.type == 1 ? 'text-green' : 'text-red'">{{ bill.type == 1 ? '+' : '-' }}{{ bill.amount || 0 }}</span>
                                <el-tag :type="bill.status === 'succ' ? 'success' : 'warning'" size="mini" style="margin-top: 5px;">{{ bill.statusText }}</el-tag>
                            </div>
                        </div>
                    </div>
                    <div class="empty-state" v-else><i class="el-icon-s-data"></i><p>暂无收入记录</p></div>
                    <div class="pagination-wrap" v-if="billTotal > 0" style="margin-top: 15px; text-align: center;">
                        <el-pagination background layout="prev, pager, next" :current-page="billPage" :page-size="billPageSize" :total="billTotal" @current-change="handleBillPageChange" small></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="支出" :name="2">
                    <div class="bill-list" v-if="billList && billList.length > 0">
                        <div class="bill-item" v-for="bill in billList" :key="bill.id">
                            <div class="bill-info">
                                <p class="bill-type">{{ bill.typeText }}</p>
                                <p class="bill-time">{{ bill.create_time }}</p>
                                <p class="bill-remark" v-if="bill.remark">{{ bill.remark }}</p>
                            </div>
                            <div class="bill-right">
                                <span class="bill-amount" :class="bill.type == 1 ? 'text-green' : 'text-red'">{{ bill.type == 1 ? '+' : '-' }}{{ bill.amount || 0 }}</span>
                                <el-tag :type="bill.status === 'succ' ? 'success' : 'warning'" size="mini" style="margin-top: 5px;">{{ bill.statusText }}</el-tag>
                            </div>
                        </div>
                    </div>
                    <div class="empty-state" v-else><i class="el-icon-s-data"></i><p>暂无支出记录</p></div>
                    <div class="pagination-wrap" v-if="billTotal > 0" style="margin-top: 15px; text-align: center;">
                        <el-pagination background layout="prev, pager, next" :current-page="billPage" :page-size="billPageSize" :total="billTotal" @current-change="handleBillPageChange" small></el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

        <!-- 提现弹窗 -->
        <el-dialog title="提现申请" :visible.sync="showWithdrawDialog" width="90%" center>
            <el-form label-width="80px" size="small">
                <el-form-item label="提现金额">
                    <el-input v-model="withdrawForm.amount" type="number" placeholder="请输入提现金额">
                        <template slot="append">元</template>
                    </el-input>
                    <div style="font-size: 12px; color: #999; margin-top: 5px;">当前余额：¥{{ walletInfo.balance || 0 }}</div>
                </el-form-item>
                <el-form-item label="收款账号">
                    <el-input v-model="withdrawForm.account" placeholder="请输入支付宝/微信/银行卡账号"></el-input>
                </el-form-item>
                <el-form-item label="收款人">
                    <el-input v-model="withdrawForm.name" placeholder="请输入收款人姓名"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="showWithdrawDialog = false" size="small">取消</el-button>
                <el-button type="primary" @click="submitWithdraw" size="small">提交申请</el-button>
            </div>
        </el-dialog>

        <!-- 教师中心弹窗 -->
        <el-dialog title="教师中心" :visible.sync="showTeacher" fullscreen>
            <div v-if="teacherStatus === 'none'">
                <div style="padding: 10px; background: #fff7e6; border-radius: 4px; margin-bottom: 15px;">
                    <p style="font-size: 12px; color: #fa8c16; margin: 0;"><i class="el-icon-info"></i> 填写真实信息，审核通过后即可发布课程</p>
                </div>
                <el-form :model="teacherApplyForm" label-width="80px" size="small">
                    <el-form-item label="真实姓名"><el-input v-model="teacherApplyForm.realName" placeholder="请输入真实姓名"></el-input></el-form-item>
                    <el-form-item label="手机号"><el-input v-model="teacherApplyForm.phone" placeholder="请输入手机号"></el-input></el-form-item>
                    <el-form-item label="身份证号"><el-input v-model="teacherApplyForm.idCard" placeholder="请输入身份证号"></el-input></el-form-item>
                    <el-form-item label="教学方向">
                        <el-select v-model="teacherApplyForm.subject" multiple placeholder="请选择教学方向" style="width: 100%;">
                            <el-option v-for="(item, index) in servers" :key="index" :label="item" :value="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="个人简介">
                        <el-input v-model="teacherApplyForm.motto" type="textarea" :rows="4" placeholder="请介绍你的教学经验、擅长领域等（不少于50字）"></el-input>
                        <div style="font-size: 12px; color: #999; margin-top: 5px;">{{ teacherApplyForm.motto ? teacherApplyForm.motto.length : 0 }}/50</div>
                    </el-form-item>
                    <el-form-item><el-button type="primary" @click="submitTeacherApply" style="width: 100%;">提交申请</el-button></el-form-item>
                </el-form>
            </div>
            <div class="audit-card" v-if="teacherStatus === 'auditing'">
                <i class="el-icon-loading"></i>
                <h3>申请已提交，审核中</h3>
                <p>你的教师入驻申请已提交，审核人员将在1-3个工作日内完成审核，请耐心等待</p>
                <div style="background: #f5f7fa; padding: 12px; border-radius: 4px; margin: 15px 0; text-align: left;">
                    <p style="font-size: 13px; color: #666; margin: 5px 0;">提交时间：{{ teacherAuditInfo.submitTime || '-' }}</p>
                    <p style="font-size: 13px; color: #666; margin: 5px 0;">预计完成时间：{{ teacherAuditInfo.expectTime || '-' }}</p>
                </div>
                <el-button type="text" @click="checkAuditStatus">刷新审核状态</el-button>
            </div>
            <div class="reject-card" v-if="teacherStatus === 'reject'">
                <i class="el-icon-circle-close"></i>
                <h3>申请已驳回</h3>
                <div style="background: #fff2f0; padding: 12px; border-radius: 4px; margin: 15px 0; text-align: left; border: 1px solid #ffccc7;">
                    <p style="font-size: 13px; font-weight: 500; color: #f56c6c; margin: 0 0 8px 0;">驳回原因：</p>
                    <p style="font-size: 13px; color: #666; margin: 0;">{{ teacherAuditInfo.rejectReason || '暂无' }}</p>
                </div>
                <el-button type="primary" @click="reSubmitTeacherApply">重新提交申请</el-button>
            </div>
            <div v-if="teacherStatus === 'passed'">
                <!-- <el-button type="primary" size="small" @click="openPublishDialog" v-if="teacherAuditInfo.substatus" style="width: 100%; margin-bottom: 15px;"><i class="el-icon-plus"></i> 发布新课程</el-button> -->
                <div class="published-course-list" v-if="publishedCourseList && publishedCourseList.length > 0">
                    <div class="course-card" v-for="course in publishedCourseList" :key="course.id">
                        <img :src="getImageUrl(course.cover)" alt="课程封面" @error="handleCourseCoverError">
                        <div class="course-info">
                            <h3>{{ course.name }}</h3>
                            <el-tag :type="course.is_sh == 0 ? 'warning' : (course.is_sh == 1 ? 'success' : 'danger')" size="mini" style="margin-bottom: 5px;">{{ course.is_sh == 0 ? '审核中' : (course.is_sh == 1 ? '已通过' : '已驳回') }}</el-tag>
                            <p><i class="el-icon-user"></i>{{ course.looks || 0 }}人学习</p>
                            <div class="course-actions">
                                <el-button type="success" size="mini" @click="manageChapter(course)">章节管理</el-button>
                                <el-button type="primary" size="mini" @click="editCourse(course)" :disabled="course.is_sh == 1">编辑</el-button>
                                <el-button type="danger" size="mini" @click="deleteCourseConfirm(course)" :disabled="course.is_sh == 1">删除</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-state" v-else>
                    <i class="el-icon-s-data"></i><p>暂无已发布课程</p>
                    <!-- <el-button type="primary" size="small" @click="openPublishDialog" v-if="teacherAuditInfo.substatus">发布第一个课程</el-button> -->
                </div>
                <div class="pagination-wrap" v-if="publishedCourseTotal > 0" style="margin-top: 15px; text-align: center;">
                    <el-pagination background layout="prev, pager, next" :current-page="publishedCoursePage" :page-size="publishedCoursePageSize" :total="publishedCourseTotal" @current-change="handlePublishedPageChange" small></el-pagination>
                </div>
            </div>
        </el-dialog>

        <!-- 账户安全弹窗 -->
        <el-dialog title="账户安全" :visible.sync="showSecurity" fullscreen>
            <div class="security-list">
                <div class="security-item" v-for="(item, index) in securityList" :key="index">
                    <div class="item-left">
                        <i :class="item.icon"></i>
                        <div><h4>{{ item.title }}</h4><p>{{ item.desc }} {{ lastLoginTime || '-' }}</p></div>
                    </div>
                    <el-button type="text" @click="item.handleClick">{{ item.btnText }}</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 修改密码弹窗 -->
        <el-dialog title="修改密码" :visible.sync="showPasswordDialog" width="90%" center>
            <el-form label-width="80px" size="small">
                <el-form-item label="手机号">
                    <el-input :value="userInfo.mobile" disabled></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input v-model="passwordForm.code" placeholder="请输入验证码">
                        <el-button slot="append" @click="sendVerifyCode" :disabled="codeCountdown > 0" size="small">
                            {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码（6位以上）" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码">
                    <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="showPasswordDialog = false" size="small">取消</el-button>
                <el-button type="primary" @click="submitPasswordChange" size="small">确定</el-button>
            </div>
        </el-dialog>

        <FooterMobile />
    </div>
</template>

<script>
import HeaderMobile from '@/components/mobile/header.vue';
import FooterMobile from '@/components/mobile/fotter.vue';
import { getUserInfo, updateAvatar, updateUserInfo, updatePassword, sendSmsCode, getWalletInfo, getTransactionList, applyWithdraw, teacherApply, publishCourse, getMyCourseList, getChapterList, publishCourseChapter, deleteCourse, deleteCourseChapter } from '@/api/user';
import { getUserCourseList, dolCollect, getConfigs, getCategory, applyRefund } from '@/api/home';
import { uploadAvatar, uploadCertificate, uploadCourseMaterial } from '@/utils/upload';
import { Session } from '@/utils/storage';
import { getCoursePublishTip } from '@/api/system';

export default {
    name: 'MobileUserCenter',
    components: { HeaderMobile, FooterMobile },
    data() {
        return {
            activeNav: '',
            resourceUrl: process.env.VUE_APP_STATIC_URL,
            courseTab: 'paid',
            coursePage: 1,
            coursePageSize: 10,
            courseTotal: 0,
            teacherStatus: '',
            userInfo: {},
            userForm: { username: '', nickname: '', mobile: '', email: '', gender: 0, birthday: '', motto: '' },
            courseList: [],
            securityList: [{ icon: 'el-icon-key', title: '登录密码', desc: '上次登录：', btnText: '修改密码', handleClick: () => this.modifyPwd() }],
            walletInfo: { balance: 0, freezeBalance: 0 },
            billList: [],
            billType: 0,
            billPage: 1,
            billPageSize: 10,
            billTotal: 0,
            teacherApplyForm: { realName: '', phone: '', idCard: '', subject: [], motto: '', certificate: [] },
            teacherAuditInfo: { submitTime: '', expectTime: '', rejectReason: '', substatus: 0 },
            publishedCourseList: [],
            publishedCoursePage: 1,
            publishedCoursePageSize: 10,
            publishedCourseTotal: 0,
            servers: [],
            certFileList: [],
            lastLoginTime: '',
            showPasswordDialog: false,
            passwordForm: { code: '', newPassword: '', confirmPassword: '' },
            codeCountdown: 0,
            showWithdrawDialog: false,
            withdrawForm: { amount: '', account: '', name: '' },
            categoryOptions: [],
            showPublishCourseDialog: false,
            coursePublishTip: '',
            publishCourseForm: { name: '', category: [], ctype: '1', is_free: '1', price: 0, desc: '', describe: '', cover: '' },
            showChapterDialog: false,
            currentCourse: null,
            chapterList: [],
            chapterPage: 1,
            chapterPageSize: 10,
            chapterTotal: 0,
            showChapterFormDialog: false,
            chapterForm: { id: null, title: '', video: '', duration: 0, file: '', sort: 0 }
        };
    },
    computed: {
        showProfile: { get() { return this.activeNav === 'profile'; }, set(val) { if (!val) this.activeNav = ''; } },
        showCourses: { get() { return this.activeNav === 'courses'; }, set(val) { if (!val) this.activeNav = ''; } },
        showWallet: { get() { return this.activeNav === 'wallet'; }, set(val) { if (!val) this.activeNav = ''; } },
        showTeacher: { get() { return this.activeNav === 'teacher'; }, set(val) { if (!val) this.activeNav = ''; } },
        showSecurity: { get() { return this.activeNav === 'security'; }, set(val) { if (!val) this.activeNav = ''; } },
        filterBillList() { return this.billList; }
    },
    mounted() { this.getConfigs(); this.loadUserInfo(); this.getWalletInfo(); this.fetchCourseList(); },
    methods: {
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        },
        getConfigs() {
            getConfigs({ type: 'teacher_servers' }).then(res => {
                if (res.code) this.servers = res.data.teacher_servers;
            }).catch(() => {});
        },
        loadUserInfo() {
            const userInfo = Session.get('userInfo');
            if (userInfo) {
                getUserInfo().then(res => {
                    if (res.code && res.data) {
                        this.userInfo = res.data;
                        this.userForm = {
                            username: res.data.username || '',
                            nickname: res.data.nickname || '',
                            mobile: res.data.mobile || '',
                            email: res.data.email || '',
                            gender: res.data.gender || 0,
                            birthday: res.data.birthday || '',
                            motto: res.data.motto || ''
                        };
                        this.lastLoginTime = res.data.last_login_time;
                        this.teacherStatus = res.data.teacherStatus;
                        this.teacherAuditInfo = res.data.teacherAuditInfo;
                    } else {
                        this.$message.error(res.msg || '获取用户信息失败');
                        this.$router.go(-1);
                    }
                }).catch(() => {
                    this.$message.error('获取用户信息失败');
                    this.$router.go(-1);
                });
            } else {
                this.$message.error('请先登录');
                this.$router.go(-1);
            }
        },
        handleAvatarError(e) { e.target.src = require('@/static/imgs/default.jpeg'); },
        handleCourseCoverError(e) { e.target.src = require('@/static/imgs/default.jpeg'); },
        saveProfile() {
            updateUserInfo(this.userForm).then(res => {
                if (res.code) {
                    this.$message.success('个人信息修改成功');
                    this.userInfo.nickname = this.userForm.nickname;
                    this.userInfo.username = this.userForm.username;
                    this.activeNav = '';
                } else {
                    this.$message.error(res.msg || '修改失败');
                }
            }).catch(() => {
                this.$message.error('修改失败');
            });
        },
        copyOrderNo(orderNo) {
            navigator.clipboard.writeText(orderNo).then(() => {
                this.$message.success('订单号已复制');
            }).catch(() => {
                const input = document.createElement('input');
                input.value = orderNo;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$message.success('订单号已复制');
            });
        },
        continueLearn(id) { this.$router.push(`/mobile/course/${id}`); },
        handleCourseTabChange() {
            this.coursePage = 1;
            this.fetchCourseList();
        },
        handleCoursePageChange(page) {
            this.coursePage = page;
            this.fetchCourseList();
        },
        fetchCourseList() {
            this.courseList = [];
            getUserCourseList({ page: this.coursePage, limit: this.coursePageSize, type: this.courseTab }).then(res => {
                if (res.code && res.data) {
                    this.courseList = res.data.list || res.data;
                    this.courseTotal = res.data.total || 0;
                }
            }).catch(() => {
                this.$message.error('获取课程列表失败');
            });
        },
        removeCourse(id) {
            this.$confirm('确定要移出该课程吗？', '提示').then(() => {
                dolCollect({ id }).then(res => {
                    if (res.code) {
                        this.$message.success('课程移出成功');
                        if (this.courseList.length === 1 && this.coursePage > 1) {
                            this.coursePage--;
                        }
                        this.fetchCourseList();
                    } else {
                        this.$message.error(res.msg || '操作失败');
                    }
                }).catch(() => {
                    this.$message.error('操作失败');
                });
            }).catch(() => {});
        },
        applyRefund(course) {
            this.$confirm(`您的退款申请，须符合《会员须知》及平台有关规定，确定要申请退款吗？`, '退款确认').then(() => {
                applyRefund({ id: course.oid }).then(res => {
                    if (res.code) {
                        this.$message.success('退款申请已提交');
                        this.fetchCourseList();
                    } else {
                        this.$message.error(res.msg || '退款申请失败');
                    }
                }).catch(() => {
                    this.$message.error('退款申请失败');
                });
            }).catch(() => {});
        },
        getWalletInfo() {
            getWalletInfo().then(res => {
                if (res.code && res.data) {
                    this.walletInfo.balance = res.data.balance || 0;
                    this.walletInfo.freezeBalance = res.data.freeze || 0;
                }
            }).catch(() => {
                this.$message.error('获取钱包信息失败');
            });
            this.getTransactionList();
        },
        getTransactionList() {
            this.billList = [];
            getTransactionList({ page: this.billPage, limit: this.billPageSize, type: this.billType }).then(res => {
                if (res.code && res.data) {
                    this.billList = (res.data.list || []).map(item => ({
                        ...item,
                        typeText: item.type === 1 ? '收入' : '支出',
                        tagType: item.type === 1 ? 'success' : 'warning',
                        statusText: item.status === 'succ' ? '已完成' : (item.status === 'cancel' ? '已取消' : (item.status === 'wait' ? '处理中' : '已失效'))
                    }));
                    this.billTotal = res.data.total || 0;
                }
            });
        },
        handleBillTypeChange() {
            this.billPage = 1;
            this.getTransactionList();
        },
        handleBillPageChange(page) {
            this.billPage = page;
            this.getTransactionList();
        },
        openWithdrawDialog() {
            this.showWithdrawDialog = true;
            this.withdrawForm = { amount: '', account: '', name: '' };
        },
        submitWithdraw() {
            if (!this.withdrawForm.amount || this.withdrawForm.amount <= 0) return this.$message.error('请输入有效的提现金额');
            if (this.withdrawForm.amount > this.walletInfo.balance) return this.$message.error('余额不足');
            if (!this.withdrawForm.account) return this.$message.error('请输入收款账号');
            if (!this.withdrawForm.name) return this.$message.error('请输入收款人姓名');
            applyWithdraw(this.withdrawForm).then(res => {
                if (res.code) {
                    this.$message.success('提现申请已提交');
                    this.showWithdrawDialog = false;
                    this.getWalletInfo();
                } else {
                    this.$message.error(res.msg || '提现申请失败');
                }
            }).catch(() => {
                this.$message.error('提现申请失败');
            });
        },
        modifyPwd() { this.showPasswordDialog = true; this.activeNav = ''; },
        sendVerifyCode() {
            if (this.codeCountdown > 0) return;
            if (!this.userInfo.mobile) return this.$message.error('请先绑定手机号');
            sendSmsCode({ mobile: this.userInfo.mobile, event: 'resetpwd' }).then(res => {
                if (res.code) {
                    this.$message.success(`验证码已发送至 ${this.userInfo.mobile}`);
                    this.codeCountdown = 60;
                    const timer = setInterval(() => {
                        this.codeCountdown--;
                        if (this.codeCountdown <= 0) clearInterval(timer);
                    }, 1000);
                } else {
                    this.$message.error(res.msg || '验证码发送失败');
                }
            }).catch(() => {
                this.$message.error('验证码发送失败');
            });
        },
        submitPasswordChange() {
            if (!this.passwordForm.code) return this.$message.error('请输入验证码');
            if (!this.passwordForm.newPassword) return this.$message.error('请输入新密码');
            if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) return this.$message.error('两次密码输入不一致');
            updatePassword({ captcha: this.passwordForm.code, newpassword: this.passwordForm.newPassword, mobile: this.userInfo.mobile }).then(res => {
                if (res.code) {
                    this.$message.success('密码修改成功');
                    this.showPasswordDialog = false;
                    this.passwordForm = { code: '', newPassword: '', confirmPassword: '' };
                } else {
                    this.$message.error(res.msg || '密码修改失败');
                }
            }).catch(() => {
                this.$message.error('密码修改失败');
            });
        },
        submitTeacherApply() {
            if (!this.teacherApplyForm.realName) return this.$message.error('请输入真实姓名');
            if (!this.teacherApplyForm.phone) return this.$message.error('请输入手机号');
            if (!this.teacherApplyForm.idCard) return this.$message.error('请输入身份证号');
            if (!this.teacherApplyForm.subject || this.teacherApplyForm.subject.length === 0) return this.$message.error('请选择教学方向');
            if (!this.teacherApplyForm.motto) return this.$message.error('请输入个人简介');
            teacherApply(this.teacherApplyForm).then(res => {
                if (res.code) {
                    this.$message.success('教师入驻申请已提交');
                    this.teacherStatus = 'auditing';
                    this.activeNav = '';
                } else {
                    this.$message.error(res.msg || '申请失败');
                }
            }).catch(() => {
                this.$message.error('申请失败');
            });
        },
        reSubmitTeacherApply() { this.teacherStatus = 'none'; this.teacherApplyForm = { realName: '', phone: '', idCard: '', subject: [], motto: '', certificate: [] }; },
        checkAuditStatus() {
            getUserInfo().then(res => {
                if (res.code) {
                    this.teacherStatus = res.data.teacherStatus;
                    this.$message.success('刷新成功');
                }
            });
        },
        uploadCertificateFile(file) {
            uploadCertificate(file).then(res => {
                if (res.code && res.data) {
                    this.teacherApplyForm.certificate.push(res.data.url);
                    this.$message.success('上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            }).catch(() => {
                this.$message.error('上传失败');
            });
        },
        getPublishedCourseList() {
            this.publishedCourseList = [];
            getMyCourseList({ page: this.publishedCoursePage, limit: this.publishedCoursePageSize }).then(res => {
                if (res.code && res.data) {
                    this.publishedCourseList = res.data.list || [];
                    this.publishedCourseTotal = res.data.total || 0;
                }
            }).catch(() => {
                this.$message.error('获取课程列表失败');
            });
        },
        handlePublishedPageChange(page) {
            this.publishedCoursePage = page;
            this.getPublishedCourseList();
        },
        openPublishDialog() {
            this.publishCourseForm = { name: '', category: [], ctype: '1', is_free: '1', price: 0, desc: '', describe: '', cover: '' };
            this.showPublishCourseDialog = true;
            this.getCategoryList();
            if (!this.coursePublishTip) {
                getCoursePublishTip().then(res => {
                    if (res.code) this.coursePublishTip = res.data.content;
                });
            }
        },
        getCategoryList() {
            getCategory().then(res => {
                if (res.code) this.categoryOptions = res.data;
            }).catch(() => {
                this.$message.error('获取分类列表失败');
            });
        },
        handleCoverUpload(e) {
            const file = e.target.files[0];
            if (!file) return;
            uploadAvatar(file).then(res => {
                if (res.code && res.data) {
                    this.publishCourseForm.cover = res.data.url;
                    this.$message.success('封面上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            }).catch(() => {
                this.$message.error('上传失败');
            });
        },
        publishCourseSubmit() {
            if (!this.publishCourseForm.name) return this.$message.error('请输入课程标题');
            if (!this.publishCourseForm.category || this.publishCourseForm.category.length === 0) return this.$message.error('请选择课程分类');
            if (this.publishCourseForm.is_free == 2 && (!this.publishCourseForm.price || this.publishCourseForm.price <= 0)) return this.$message.error('请输入有效的课程价格');
            if (!this.publishCourseForm.cover) return this.$message.error('请上传课程封面');
            publishCourse(this.publishCourseForm).then(res => {
                if (res.code) {
                    this.$message.success('课程发布成功');
                    this.showPublishCourseDialog = false;
                    this.publishedCoursePage = 1;
                    this.getPublishedCourseList();
                } else {
                    this.$message.error(res.msg || '课程发布失败');
                }
            }).catch(() => {
                this.$message.error('课程发布失败');
            });
        },
        manageChapter(course) {
            this.currentCourse = course;
            this.chapterPage = 1;
            this.getChapterList(course.id);
            this.showChapterDialog = true;
        },
        getChapterList(courseId) {
            this.chapterList = [];
            getChapterList({ id: courseId, page: this.chapterPage, limit: this.chapterPageSize }).then(res => {
                if (res.code && res.data) {
                    this.chapterList = res.data.list || res.data;
                    this.chapterTotal = res.data.total || 0;
                }
            }).catch(() => {
                this.$message.error('获取章节列表失败');
            });
        },
        handleChapterPageChange(page) {
            this.chapterPage = page;
            this.getChapterList(this.currentCourse.id);
        },
        addChapter() {
            this.chapterForm = { id: null, title: '', video: '', duration: 0, file: '', sort: 0 };
            this.showChapterFormDialog = true;
        },
        editChapter(chapter) {
            this.chapterForm = { ...chapter };
            this.showChapterFormDialog = true;
        },
        handleVideoUpload(e) {
            const file = e.target.files[0];
            if (!file) return;
            uploadCourseMaterial(file).then(res => {
                if (res.code && res.data) {
                    this.chapterForm.video = res.data.url;
                    this.$message.success('视频上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            }).catch(() => {
                this.$message.error('上传失败');
            });
        },
        handleFileUpload(e) {
            const file = e.target.files[0];
            if (!file) return;
            uploadCourseMaterial(file).then(res => {
                if (res.code && res.data) {
                    this.chapterForm.file = res.data.url;
                    this.$message.success('文件上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            }).catch(() => {
                this.$message.error('上传失败');
            });
        },
        saveChapter() {
            if (!this.chapterForm.title) return this.$message.error('请输入章节标题');
            if (this.currentCourse && this.currentCourse.ctype == 1 && !this.chapterForm.video) return this.$message.error('请上传视频');
            if (this.currentCourse && this.currentCourse.ctype == 2 && !this.chapterForm.file) return this.$message.error('请上传文件');
            const data = { ...this.chapterForm, course_id: this.currentCourse.id };
            publishCourseChapter(data).then(res => {
                if (res.code) {
                    this.$message.success('保存成功');
                    this.showChapterFormDialog = false;
                    this.getChapterList(this.currentCourse.id);
                } else {
                    this.$message.error(res.msg || '保存失败');
                }
            }).catch(() => {
                this.$message.error('保存失败');
            });
        },
        deleteChapter(chapter) {
            this.$confirm('确定要删除该章节吗？', '提示').then(() => {
                deleteCourseChapter({ id: chapter.id }).then(res => {
                    if (res.code) {
                        this.$message.success('删除成功');
                        this.getChapterList(this.currentCourse.id);
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                }).catch(() => {
                    this.$message.error('删除失败');
                });
            }).catch(() => {});
        },
        editCourse(course) { 
            if (course.is_sh == 1) return this.$message.warning('课程已审核通过，无法编辑');
            this.$message.info(`编辑课程ID：${course.id}`);
            if (!this.coursePublishTip) {
                getCoursePublishTip().then(res => {
                    if (res.code) this.coursePublishTip = res.data.content;
                });
            }
        },
        deleteCourseConfirm(course) { 
            if (course.is_sh == 1) return this.$message.warning('课程已审核通过，无法删除');
            this.$confirm('确定要删除该课程吗？', '提示').then(() => { 
                deleteCourse({ id: course.id }).then(res => {
                    if (res.code) {
                        this.$message.success('课程删除成功');
                        this.getPublishedCourseList();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                }).catch(() => {
                    this.$message.error('删除失败');
                });
            }).catch(() => {}); 
        }
    }
};
</script>

<style scoped>
.mobile-user-center { min-height: 100vh; background: #f5f5f5; padding-top: 60px; }
.user-info-card { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 20px; color: #fff; }
.user-header { display: flex; align-items: center; gap: 15px; margin-bottom: 20px; }
.user-avatar { width: 60px; height: 60px; border-radius: 50%; border: 3px solid rgba(255,255,255,0.3); }
.user-base h3 { font-size: 18px; margin-bottom: 5px; }
.user-base p { font-size: 12px; padding: 2px 8px; border-radius: 12px; display: inline-block; }
.teacher-role, .student-role { background: rgba(255,255,255,0.2); }
.user-stats { display: flex; justify-content: space-around; padding-top: 15px; border-top: 1px solid rgba(255,255,255,0.2); }
.stats-item { text-align: center; }
.stats-num { font-size: 20px; font-weight: 600; display: block; margin-bottom: 4px; }
.stats-text { font-size: 12px; opacity: 0.8; }
.menu-list { background: #fff; margin: 10px 15px; border-radius: 8px; }
.menu-item { display: flex; align-items: center; padding: 15px; border-bottom: 1px solid #f0f0f0; }
.menu-item:last-child { border-bottom: none; }
.menu-item i:first-child { font-size: 20px; color: #1890ff; margin-right: 12px; }
.menu-item span { flex: 1; font-size: 14px; }
.menu-item i:last-child { color: #999; }
.course-list, .published-course-list { display: flex; flex-direction: column; gap: 10px; }
.course-item, .course-card { background: #f8f8f8; border-radius: 8px; padding: 12px; display: flex; gap: 12px; }
.course-item img, .course-card img { width: 100px; height: 75px; border-radius: 4px; object-fit: cover; }
.course-info { flex: 1; }
.course-info h3 { font-size: 14px; margin-bottom: 8px; }
.course-info p { font-size: 12px; color: #666; margin-bottom: 8px; }
.course-actions { display: flex; gap: 8px; }
.empty-state { text-align: center; padding: 60px 20px; color: #94a3b8; }
.empty-state i { font-size: 64px; margin-bottom: 16px; color: #cbd5e1; }
.empty-state p { font-size: 14px; margin-bottom: 20px; }
.wallet-balance { background: linear-gradient(135deg, #1890ff, #40a9ff); border-radius: 8px; padding: 20px; color: #fff; text-align: center; margin-bottom: 20px; }
.wallet-balance p { font-size: 14px; opacity: 0.8; margin-bottom: 8px; }
.wallet-balance h2 { font-size: 32px; font-weight: 700; }
.bill-list h3 { font-size: 16px; margin-bottom: 15px; }
.bill-item { display: flex; justify-content: space-between; align-items: center; padding: 12px; background: #f8f8f8; border-radius: 8px; margin-bottom: 8px; }
.bill-info { flex: 1; }
.bill-type { font-size: 14px; margin-bottom: 4px; font-weight: 500; }
.bill-time { font-size: 12px; color: #999; margin-bottom: 2px; }
.bill-remark { font-size: 12px; color: #666; margin-top: 4px; }
.bill-right { display: flex; flex-direction: column; align-items: flex-end; }
.bill-amount { font-size: 16px; font-weight: 600; }
.text-green { color: #52c41a; }
.text-red { color: #f56c6c; }
.security-list { display: flex; flex-direction: column; gap: 10px; }
.security-item { display: flex; justify-content: space-between; align-items: center; padding: 15px; background: #f8f8f8; border-radius: 8px; }
.item-left { display: flex; align-items: center; gap: 12px; }
.item-left i { font-size: 24px; color: #1890ff; }
.item-left h4 { font-size: 14px; margin-bottom: 4px; }
.item-left p { font-size: 12px; color: #666; }
.audit-card, .reject-card { text-align: center; padding: 40px 20px; }
.audit-card i { font-size: 48px; color: #1890ff; margin-bottom: 16px; animation: rotate 1.5s linear infinite; }
@keyframes rotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
.reject-card i { font-size: 48px; color: #f56c6c; margin-bottom: 16px; }
.audit-card h3, .reject-card h3 { font-size: 18px; margin-bottom: 8px; }
.audit-card p, .reject-card p { font-size: 14px; color: #666; margin-bottom: 20px; }
</style>

        <!-- 发布课程弹窗 -->
        <el-dialog title="发布新课程" :visible.sync="showPublishCourseDialog" width="90%" center>
            <div v-if="coursePublishTip" v-html="coursePublishTip" style="background:#fffbe6;border:1px solid #ffe58f;border-radius:6px;padding:12px;margin-bottom:15px;font-size:13px;color:#614700;line-height:1.8;"></div>
            <el-form :model="publishCourseForm" label-width="80px" size="small">
                <el-form-item label="课程标题"><el-input v-model="publishCourseForm.name" placeholder="请输入课程标题"></el-input></el-form-item>
                <el-form-item label="课程分类">
                    <el-cascader v-model="publishCourseForm.category" :options="categoryOptions" :props="{ value: 'id', label: 'name', children: 'children' }" placeholder="请选择课程分类" style="width: 100%;" filterable clearable></el-cascader>
                </el-form-item>
                <el-form-item label="课程类型">
                    <el-radio-group v-model="publishCourseForm.ctype">
                        <el-radio label="1">视频课程</el-radio>
                        <el-radio label="2">文件课程</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否免费">
                    <el-radio-group v-model="publishCourseForm.is_free">
                        <el-radio label="1">免费</el-radio>
                        <el-radio label="2">付费</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="课程价格" v-if="publishCourseForm.is_free == 2">
                    <el-input v-model="publishCourseForm.price" type="number" placeholder="请输入课程价格"><template slot="append">元</template></el-input>
                </el-form-item>
                <el-form-item label="课程封面">
                    <input type="file" accept="image/*" @change="handleCoverUpload" style="display: none;" ref="coverInput">
                    <div @click="$refs.coverInput.click()" style="width: 100px; height: 100px; border: 1px dashed #d9d9d9; border-radius: 4px; display: flex; align-items: center; justify-content: center; cursor: pointer; overflow: hidden;">
                        <img v-if="publishCourseForm.cover" :src="getImageUrl(publishCourseForm.cover)" style="width: 100%; height: 100%; object-fit: cover;">
                        <div v-else style="text-align: center; color: #999;"><i class="el-icon-plus" style="font-size: 24px;"></i><p style="font-size: 12px; margin: 5px 0 0 0;">上传封面</p></div>
                    </div>
                </el-form-item>
                <el-form-item label="课程简介"><el-input v-model="publishCourseForm.desc" placeholder="请输入课程简介"></el-input></el-form-item>
                <el-form-item label="课程描述"><el-input v-model="publishCourseForm.describe" type="textarea" :rows="3" placeholder="请输入课程描述"></el-input></el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="showPublishCourseDialog = false" size="small">取消</el-button>
                <el-button type="primary" @click="publishCourseSubmit" size="small">保存课程</el-button>
            </div>
        </el-dialog>

        <!-- 章节管理弹窗 -->
        <el-dialog :title="(currentCourse && '【' + currentCourse.name + '】') + '章节管理'" :visible.sync="showChapterDialog" width="90%" center>
            <el-button type="primary" size="small" @click="addChapter" v-if="currentCourse && currentCourse.is_sh != 1" style="width: 100%; margin-bottom: 15px;"><i class="el-icon-plus"></i> 添加章节</el-button>
            <div v-if="chapterList && chapterList.length > 0">
                <div v-for="chapter in chapterList" :key="chapter.id" style="background: #f8f8f8; padding: 12px; border-radius: 4px; margin-bottom: 10px;">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div style="flex: 1;">
                            <h4 style="margin: 0 0 5px 0; font-size: 14px;">{{ chapter.name }}</h4>
                            <p style="margin: 0; font-size: 12px; color: #999;">排序: {{ chapter.listorder }} | {{ currentCourse.ctype == 1 ? '时长: ' + chapter.duration + '秒' : '文件' }}</p>
                        </div>
                        <div>
                            <el-button type="text" size="small" @click="editChapter(chapter)" :disabled="currentCourse.is_sh == 1">编辑</el-button>
                            <el-button type="text" size="small" @click="deleteChapter(chapter)" :disabled="currentCourse.is_sh == 1" style="color: #f56c6c;">删除</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="empty-state" v-else><i class="el-icon-s-data"></i><p>暂无章节</p></div>
            <div class="pagination-wrap" v-if="chapterTotal > 0" style="margin-top: 15px; text-align: center;">
                <el-pagination background layout="prev, pager, next" :current-page="chapterPage" :page-size="chapterPageSize" :total="chapterTotal" @current-change="handleChapterPageChange" small></el-pagination>
            </div>
        </el-dialog>

        <!-- 章节编辑弹窗 -->
        <el-dialog :title="chapterForm.id ? '编辑章节' : '添加章节'" :visible.sync="showChapterFormDialog" width="90%" center>
            <el-form :model="chapterForm" label-width="80px" size="small">
                <el-form-item label="章节标题"><el-input v-model="chapterForm.title" placeholder="请输入章节标题"></el-input></el-form-item>
                <template v-if="currentCourse && currentCourse.ctype == 1">
                    <el-form-item label="视频上传">
                        <input type="file" accept="video/*" @change="handleVideoUpload" style="display: none;" ref="videoInput">
                        <el-button size="small" @click="$refs.videoInput.click()"><i class="el-icon-upload"></i> {{ chapterForm.video ? '重新上传' : '上传视频' }}</el-button>
                        <div v-if="chapterForm.video" style="font-size: 12px; color: #52c41a; margin-top: 5px;"><i class="el-icon-success"></i> 已上传视频</div>
                    </el-form-item>
                    <el-form-item label="视频时长"><el-input v-model="chapterForm.duration" type="number" placeholder="请输入时长（秒）"><template slot="append">秒</template></el-input></el-form-item>
                </template>
                <template v-if="currentCourse && currentCourse.ctype == 2">
                    <el-form-item label="文件上传">
                        <input type="file" @change="handleFileUpload" style="display: none;" ref="fileInput">
                        <el-button size="small" @click="$refs.fileInput.click()"><i class="el-icon-upload"></i> {{ chapterForm.file ? '重新上传' : '上传文件' }}</el-button>
                        <div v-if="chapterForm.file" style="font-size: 12px; color: #52c41a; margin-top: 5px;"><i class="el-icon-success"></i> 已上传文件</div>
                    </el-form-item>
                </template>
                <el-form-item label="排序"><el-input-number v-model="chapterForm.sort" :min="0" placeholder="请输入排序" style="width: 100%;"></el-input-number></el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="showChapterFormDialog = false" size="small">取消</el-button>
                <el-button type="primary" @click="saveChapter" size="small">保存</el-button>
            </div>
        </el-dialog>
